import { render, staticRenderFns } from "./MsgDetails.vue?vue&type=template&id=5df4f4c7&scoped=true&"
import script from "./MsgDetails.vue?vue&type=script&lang=js&"
export * from "./MsgDetails.vue?vue&type=script&lang=js&"
import style0 from "./MsgDetails.vue?vue&type=style&index=0&id=5df4f4c7&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df4f4c7",
  null
  
)

export default component.exports